<template>
    <div>
        <div class="row">
            <b-form-group label="Дата выполнения" :label-for="`${id}-date`" class="col-7 pr-1">
                <b-form-input :id="`${id}-date`" v-model="date" type="date" :min="today"
                    :disabled="disabled" @input="update" />
            </b-form-group>
            <b-form-group label="Время" :label-for="`${id}-time`" class="col-5 pl-1">
                <b-form-input :id="`${id}-time`" v-model="time" type="time" :disabled="disabled" @input="update" />
            </b-form-group>
        </div>
        <p class="small text-muted mt-n2">Минск / Москва, UTC+3</p>
    </div>
</template>
<script>
import {deadlineParts, composeDeadline, deadlinePolicy} from '@/utils/requestDeadline';
export default {
    name: 'RequestDeadlineInput',
    props: {
        value: {default: null},
        id: {type: String, default: 'request-deadline'},
        disabled: Boolean,
        now: {type: Number, default: () => Date.now()}
    },
    data() { return deadlineParts(this.value); },
    computed: {today() { return deadlinePolicy({}, {}, this.now).today; }},
    watch: {
        value(value) {
            if (value !== composeDeadline(this.date, this.time)) Object.assign(this, deadlineParts(value));
        }
    },
    methods: {update() { this.$emit('input', composeDeadline(this.date, this.time)); }}
};
</script>
